import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { keys } from '@/api/queryKeys';
import { settingsApi } from '../api/settingsApi';
import type { SettingsCarrier } from '../api/types';

export function useCarriers(includeInactive = false) {
  return useQuery({
    queryKey: [...keys.settings.carriers, includeInactive],
    queryFn: ({ signal }) => settingsApi.getCarriers(includeInactive, { signal }),
    staleTime: 300_000,
  });
}

export function useCreateCarrier() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (data: Partial<SettingsCarrier>) => settingsApi.createCarrier(data),
    onSuccess: () => {
      void queryClient.invalidateQueries({ queryKey: keys.settings.carriers });
    },
  });
}

export function useDeleteCarrier() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (carrierId: number) => settingsApi.deleteCarrier(carrierId),
    onSuccess: () => {
      void queryClient.invalidateQueries({ queryKey: keys.settings.carriers });
    },
  });
}
